"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListStyled = exports.ListItemStyled = void 0;

var _utils = require("../../utils");

var _const = require("../../const");

var _templateObject, _templateObject2, _templateObject3;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ListItemStyled = (0, _utils.styled)('li')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n  ", "\n"])), function (props) {
  return (0, _const.spacingStyle)(props);
}, function (_ref) {
  var display = _ref.display;
  return (0, _const.displayHelperStyle)(display);
});
exports.ListItemStyled = ListItemStyled;
var listStyleCheck = (0, _utils.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: relative;\n  padding-left: 28px;\n  &:before {\n    width: 19px;\n    height: 13px;\n    display: block;\n    position: absolute;\n    content: '';\n    left: 0;\n    top: 50%;\n    margin: -6.5px 0 0;\n    background-image: url(data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjIwIiB2aWV3Qm94PSIwIDAgMjkgMjAiIHdpZHRoPSIyOSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJtOTUuOTYgMzU3LjAxOTg0NS04LjYwODQwNTMtOC41MTM4MDhjLS4xOTYzMzgtLjE5NDE4LS41MTI5MTU2LS4xOTI0MzEtLjcwNzA5Ni4wMDM5MDdzLS4xOTI0MzEzLjUxMjkxNS4wMDM5MDY2LjcwNzA5Nmw4Ljk2IDguODYxNTM4Yy4xOTQ4MDU3LjE5MjY2NS41MDgzODM3LjE5MjY2NS43MDMxODk0IDBsMTcuOTIwMDAwMy0xNy43MjMwNzdjLjE5NjMzOC0uMTk0MTguMTk4MDg3LS41MTA3NTguMDAzOTA2LS43MDcwOTYtLjE5NDE4LS4xOTYzMzgtLjUxMDc1OC0uMTk4MDg3LS43MDcwOTYtLjAwMzkwNnoiIGZpbGw9IiMyMDdjN2IiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC04NiAtMzM5KSIvPjwvc3ZnPg==);\n    background-position: 50% 50%;\n    background-repeat: no-repeat;\n    background-size: contain;\n  }\n"])));
var ListStyled = (0, _utils.styled)('ul')(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  text-transform: ", ";\n  font-size: ", ";\n  letter-spacing: ", ";\n  ", " {\n    padding: ", ";\n    display: ", ";\n    ", ";\n    ", "\n  }\n"])), function (_ref2) {
  var color = _ref2.color;
  return color && (0, _const.colorHelperStyle)(color);
}, function (props) {
  return (0, _const.spacingStyle)(props);
}, function (_ref3) {
  var uppercase = _ref3.uppercase;
  return uppercase ? 'uppercase' : 'none';
}, function (_ref4) {
  var measure = _ref4.measure;
  return _const.TextSize[measure];
}, function (_ref5) {
  var letterSpacing = _ref5.letterSpacing;
  return letterSpacing ? "".concat(letterSpacing, "px") : 'normal';
}, ListItemStyled, function (_ref6) {
  var group = _ref6.group;
  return group ? '15px 15px' : '0';
}, function (_ref7) {
  var inline = _ref7.inline;
  return inline ? 'inline-block' : 'block';
}, function (_ref8) {
  var color = _ref8.color;
  return color && (0, _const.colorHelperStyle)(color);
}, function (_ref9) {
  var listStyle = _ref9.listStyle;
  return listStyle == 'check' && listStyleCheck;
});
exports.ListStyled = ListStyled;